export interface ErrorObj {
	code: number;
	errorNumber: number;
	message: string;
	message2: string;
}
export interface Message2Obj {
	field: string;
	errors: string[];
}

export const parseError = (errorStr: string | null | undefined): string => {
	if (!errorStr) {
		return 'Error';
	}

	errorStr = errorStr.replace(/\(?\d+\)?\s*- /, '');
	return errorStr;
};
